<section class="beta-details">
  <p>As we're in Beta we are currently only accepting invited users.</p>
  <p>Please contact us at <a href="mailto:signup@cykubed.com">signup&#64;cykubed.com</a> if you want to take part.</p>
  <p>Thanks</p>
</section>
